import { render, staticRenderFns } from "./law_firms_add.vue?vue&type=template&id=caa9ba8a&scoped=true"
import script from "./law_firms_add.vue?vue&type=script&lang=js"
export * from "./law_firms_add.vue?vue&type=script&lang=js"
import style0 from "./law_firms_add.vue?vue&type=style&index=0&id=caa9ba8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa9ba8a",
  null
  
)

export default component.exports